import React, { useState } from 'react';
import {
    SearchHeading,
    SearchHeader,
    EmptyBox,
} from 'src/pages/orders/components/searchOrdersPanel/SearchOrdersPanel.styled';
import {
    FilterContentMain,
    Reset,
    TextBold,
    FilterBlock,
} from 'src/common/components/filter/Filters.styled.jsx';
import { Container } from 'src/pages/more/pages/accounts/components/accountSearchBox/index.styled';
import { Title } from 'src/pages/orders/components/orderDetails/replenRequest/ReplenRequest.styled';
import {
    FilterWrapperMain,
    DetailsMainContainerBlock,
} from 'src/pages/more/pages/physicians/components/physicianSearchBox/index.styled';
import { MainContainerItems } from 'src/pages/orders/components/orderDetails/backOrderDetails/BackOrderDetails.styled';
import BottomNavigation from 'src/common/refactoredComponents/bottomNavigation/BottomNavigation';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import InputBox from 'src/common/refactoredComponents/input/Input';
import { useTranslation } from 'react-i18next';
import {
    setPhysicianSearchOpen,
    setSearchParamsPhy,
} from 'src/pages/more/redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import { getPhysicianDetails } from 'src/pages/more/redux/actions';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { logErrorToConsole } from 'src/utils/util';

const PhysicianSearchBox = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [showSearchButton, setShowSearchButton] = useState(false);
    const onKeyboardOpenHandler = () => {
        document.body.scrollTop = 0;
        window.onscroll = function () {
            window.scrollTo(0, 0);
        };
    };
    const salesOrg = useSelector((state) => state.loginReducer.salesOrg);
    const countryISOCode = useSelector((state) => state.loginReducer.hybrisUserDetails.countryISOCode);
    useEffectWithErrorLogging(() => {
        window.visualViewport.addEventListener('resize', onKeyboardOpenHandler);
        window.visualViewport.addEventListener('scroll', onKeyboardOpenHandler);
        return () => {
            window.visualViewport.removeEventListener(
                'resize',
                onKeyboardOpenHandler
            );
            window.visualViewport.removeEventListener(
                'scroll',
                onKeyboardOpenHandler
            );
        };
    }, []);

    const [inputFields, setInputFields] = useState({
        physicianName: '',
        hcpID: '',
        accountNameOrNumber: '',
        city: '',
        state: '',
    });

    const onChangeHandler = (fieldName, value) => {
        setInputFields({
            ...inputFields,
            [fieldName]: value,
        });
    };

    const { physicianName, hcpID, accountNameOrNumber, city, state } =
        inputFields;

    const resetHandler = () => {
        props.setSearchParamValues('');
        setInputFields((inputFields) => ({
            ...inputFields,
            physicianName: '',
            hcpID: '',
            accountNameOrNumber: '',
            city: '',
            state: '',
        }));
    };
    //changes
    const handleClick = () => {
        dispatch(setSearchParamsPhy(inputFields));
        if (
            inputFields.physicianName !== '' ||
            inputFields.hcpID !== '' ||
            inputFields.accountNameOrNumber !== '' ||
            inputFields.city !== '' ||
            inputFields.state !== ''
        ) {
            // let isnum = /^\d+$/.test(inputFields.accountNameOrNumber);
            // console.log(isnum, 'isNum');
            // const accountNum = isnum
            //     ? inputFields.accountNameOrNumber !== '' &&
            //       (inputFields.accountNameOrNumber === '000' ||
            //           inputFields.accountNameOrNumber.substring(0, 3) !== '000')
            //         ? '000' + accountNameOrNumber
            //         : accountNameOrNumber
            //     : accountNameOrNumber;
            let searchParam = {
                physicianName: inputFields.physicianName,
                hcpId: inputFields.hcpID,
                AccountNameNo: inputFields.accountNameOrNumber,
                city: inputFields.city,
                state: inputFields.state,
            };
            // const pageParam = { pageNum: page };
            props.setSearchParamValues(searchParam);
            // const param = { ...pageParam, ...searchParam };
            dispatch(getPhysicianDetails(searchParam, true));
            dispatch(setPhysicianSearchOpen(true));
        } else {
            dispatch(setPhysicianSearchOpen(false));
        }
        props.onClose();
    };

    useEffectWithErrorLogging(() => {
        if(Object.keys(inputFields).some((key) => inputFields[key]!='')) {
            setShowSearchButton(true);
        } else {
            setShowSearchButton(false);
        }
        if (props.showSearch) {
            const listener = (event) => {
                if (
                    event.code === 'Enter' ||
                    event.code === 'NumpadEnter' ||
                    event.key === 'Enter'
                ) {
                    event.preventDefault();
                    handleClick();
                }
            };
            document.addEventListener('keydown', listener);
            return () => {
                document.removeEventListener('keydown', listener);
            };
        }
    },[inputFields]);

    return (
        <FilterBlock>
            <FilterWrapperMain className="FilterWrapperMain" bannerHeight={props.bannerHeight}>
                <SearchHeader mobileMarginBottom={'0.3rem'}>
                    <SearchHeading>
                        {t('physicians.searchBox.search')}
                    </SearchHeading>
                    <Reset onClick={resetHandler}>
                        {t('physicians.searchBox.reset')}
                    </Reset>
                </SearchHeader>
                <FilterContentMain>
                    <DetailsMainContainerBlock>
                        <Container>
                            <MainContainerItems
                                width={'100%'}
                                marginBottom={'16px'}
                                ipadPadding={'0rem 0.1rem'}
                            >
                                <Title
                                    color={'#202124'}
                                    fontSize={'14px'}
                                    marginBottom={'5px'}
                                >
                                    {t(
                                        'physicians.searchBox.physicianName.title'
                                    )}
                                </Title>
                                <InputBox
                                    placeholder={t(
                                        'physicians.searchBox.physicianName.placeholder'
                                    )}
                                    value={physicianName}
                                    id={'more-physicians-physicianSearchBox-physicianName'}
                                    onChange={(event) =>
                                        onChangeHandler(
                                            'physicianName',
                                            event.target.value
                                        )
                                    }
                                />
                            </MainContainerItems>
                            <MainContainerItems
                                width={'100%'}
                                marginBottom={'16px'}
                                ipadPadding={'0rem 0.1rem'}
                            >
                                <Title
                                    color={'#202124'}
                                    fontSize={'14px'}
                                    marginBottom={'5px'}
                                >   
                                    {salesOrg === 'S024' || countryISOCode === 'JP'
                                        ? t('physicians.searchBox.sapId.title')
                                        : t('physicians.searchBox.hcpID.title')}
                                </Title>
                                <InputBox
                                    placeholder=
                                    {(salesOrg==='S024' || countryISOCode ==='JP')?t(
                                        'physicians.searchBox.sapId.placeholder'
                                    ):t(
                                        'physicians.searchBox.hcpID.placeholder'
                                    )}
                                    // {t(
                                    //     'physicians.searchBox.hcpID.placeholder'
                                    // )}
                                    onChange={(event) =>
                                        onChangeHandler(
                                            'hcpID',
                                            event.target.value
                                        )
                                    }
                                    value={hcpID}
                                    id={'more-physicians-physicianSearchBox-hcpID'}
                                />
                            </MainContainerItems>
                            <MainContainerItems
                                width={'100%'}
                                marginBottom={'16px'}
                                ipadPadding={'0rem 0.1rem'}
                            >
                                <Title
                                    color={'#202124'}
                                    fontSize={'14px'}
                                    marginBottom={'5px'}
                                >
                                    {t(
                                        'physicians.searchBox.accountNameNumber.title'
                                    )}
                                </Title>
                                <InputBox
                                    placeholder={t(
                                        'physicians.searchBox.accountNameNumber.placeholder'
                                    )}
                                    onChange={(event) =>
                                        onChangeHandler(
                                            'accountNameOrNumber',
                                            event.target.value
                                        )
                                    }
                                    value={accountNameOrNumber}
                                    id={'more-physicians-physicianSearchBox-accountNameOrNumber'}
                                />
                            </MainContainerItems>
                            <MainContainerItems
                                width={'100%'}
                                marginBottom={'16px'}
                                ipadPadding={'0rem 0.1rem'}
                            >
                                <Title
                                    color={'#202124'}
                                    fontSize={'14px'}
                                    marginBottom={'5px'}
                                >
                                    {t('physicians.searchBox.city.title')}
                                </Title>
                                <InputBox
                                    placeholder={t(
                                        'physicians.searchBox.city.placeholder'
                                    )}
                                    onChange={(event) =>
                                        onChangeHandler(
                                            'city',
                                            event.target.value
                                        )
                                    }
                                    value={city}
                                    id={'more-physicians-physicianSearchBox-city'}
                                />
                            </MainContainerItems>
                            <MainContainerItems
                                width={'100%'}
                                marginBottom={'16px'}
                                ipadPadding={'0rem 0.1rem'}
                            >
                                <Title
                                    color={'#202124'}
                                    fontSize={'14px'}
                                    marginBottom={'5px'}
                                >
                                    {t('physicians.searchBox.state.title')}
                                </Title>
                                <InputBox
                                    placeholder={t(
                                        'physicians.searchBox.state.placeholder'
                                    )}
                                    onChange={(event) =>
                                        onChangeHandler(
                                            'state',
                                            event.target.value
                                        )
                                    }
                                    value={state}
                                    id={'more-physicians-physicianSearchBox-state'}
                                />
                            </MainContainerItems>
                        </Container>
                    </DetailsMainContainerBlock>
                    <EmptyBox mobileMargin="50%"></EmptyBox>

                    <BottomNavigation
                        justifyContent={'space-evenly'}
                        iPadPortraitJustifyContent={'space-evenly'}
                        opacity={'1'}
                        padding={'11px'}
                        position={'sticky'}
                    >
                        <Button
                        id={'physicians-physicianSearchBox-closeButton'}
                            show={true}
                            // secondary={true}
                            variant={ButtonStyles?.secondary}
                            width={'40%'}
                            height={'38px'}
                            //clicked={onClose}
                            clicked={() => {
                                try {
                                    props.onClose();
                                } catch (error) {
                                    logErrorToConsole(error);
                                }
                            }}
                        >
                            <TextBold color={'#1010EB'}>
                                {t('physicians.searchBox.close')}
                            </TextBold>
                        </Button>
                        <Button
                        id={'physicians-physicianSearchBox-searchButton'}
                            show={true}
                            // primary={showSearchButton}
                            disabled={!showSearchButton}
                            variant={showSearchButton ? ButtonStyles?.primary : ButtonStyles?.disabled}
                            width={'40%'}
                            height={'38px'}
                            clicked={() => {
                                try {
                                    handleClick();
                                } catch (error) {
                                    logErrorToConsole(error);
                                }
                            }}
                        >
                            <TextBold color={'#FFFF'}>
                                {t('physicians.searchBox.search')}
                            </TextBold>
                        </Button>
                    </BottomNavigation>
                </FilterContentMain>
            </FilterWrapperMain>
        </FilterBlock>
    );
};

export default PhysicianSearchBox;
